<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                      <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                      <div class="flex-1">
                        <h3 class="m-0">Cari Cepat</h3>
                        <p class="mb-0">Pencarian satset disini</p>
                      </div>
                    </div>
                    <div class="card mt-2">
                      <div class="card-body">
                          <div class="row">
                            <div class="col-md-6 cariByTanggal">
                              <div class="form-group">
                                <input type="text" class="form-control" placeholder="Cari Cepat..." v-model="dataAll.telepon" />
                              </div>
                            </div>
                            <div class="col-md-2 cariByTanggal">
                                <div class="form-group">
                                <button  class="btn btn-info" @click="theGet.cariTeleponApi()">Cari</button>
                              </div>
                            </div>
                          </div>
                          
                          <div class="table-responsive">
                            <table class="table">
                              <thead class=" text-info">
                                <th>No.</th>
                                <th>Nama</th>
                                <th>PPOE</th>
                                <th>Paket</th>
                                <th>Area</th>
                                <th>Biaya</th>
                                <th>Tanggal Register</th>
                                <th>Status Bayar</th>
                              </thead>
                              <tbody v-show="dataAll.loading">
                                <tr>
                                  <td colspan="8"><Loading></Loading></td>
                                </tr>
                                <tr>
                                  <td colspan="8"><Loading></Loading></td>
                                </tr>
                                <tr>
                                  <td colspan="8"><Loading></Loading></td>
                                </tr>
                              </tbody>
                              
                              <tbody v-show="theGet.data.List.length == 0">
                                <tr>
                                  <td></td>
                                  <td>Tidak ada Data '{{dataAll.telepon}}'</td>
                                </tr>
                              </tbody>
                              <tbody v-show="!dataAll.loading">
                                <tr v-for="(u, index) in theGet.data.List">
                                  <td>{{ index+1 }}</td>
                                  <td>
                                    <strong class="h4 text-info">
                                      <router-link :to="{ name: 'pelanggan-detail', params: { id:u.user.uid, user: u.user, area: u.area}}"   class="text-info" >( {{dataAll.prefix + "" + u.user.fake_id}} )  {{ u.user.unama }}
                                      </router-link></strong></br>
                                      {{ u.user.wa }}</br>
                                      <i class="material-icons text-info" style="font-size: 12pt;" v-if="u.user.mikrotik_id !=null">router</i>
                                      <i class="material-icons text-warning" style="font-size: 12pt;" v-if="u.user.lat !=null">location_on</i>
                                  </td>
                                  <td><span class="text-info">{{ u.user.ppoe }}</span></br>{{ u.user.modem_info }}</td>
                                  <td>{{ u.user.pnama }}</br><span class="text-secondary">Tagihan Tgl</span> {{ u.user.tanggal_tagihan }}</td>
                                  <td>{{ u.area }}</td>
                                  <td>
                                    {{ ribu( ( ( parseInt(u.user.ptarif) + parseInt(myGlobal.isNull(u.user.biaya_tambahan)) + parseInt(myGlobal.isNull(u.user.biaya_tambahan_2)) ) + (  ( parseInt(u.user.ptarif) / 100 ) ) * parseInt(dataAll.ppn)   ) - parseInt(myGlobal.isNull(u.user.diskon)) ) }} <i class="tombol material-icons text-info" @mouseover="dataAll.infoShow = index" @mouseleave="dataAll.infoShow = -1">error</i> 
                                    <span class="info" v-if="dataAll.infoShow == index" v-show="dataAll.infoShow == index">
                                      <p class="mb-0">PPN {{dataAll.ppn}}% : {{ribu(parseInt(dataAll.ppn) * ( parseInt(u.user.ptarif) / 100 ) )}}</p>
                                      <p v-if="u.user.biaya_rincian != null" class="mb-0">{{u.user.biaya_rincian}} : {{ribu(u.user.biaya_tambahan) }}</p>
                                      <p v-if="u.user.biaya_rincian_2 != null" class="mb-0">{{u.user.biaya_rincian_2}} : {{ribu(u.user.biaya_tambahan_2) }}</p>
                                      <p class="mb-0">Diskon : {{ribu(myGlobal.isNull(u.user.diskon)) }}</p>
                                    </span>
                                  </td>
                                  <td>{{ tglIndo(u.user.tanggal_register) }}</td>
                                  <td>
                                    <span class="text-warning" v-if="u.user.status_sekarang == 'BELUM BAYAR'">{{ u.user.status_sekarang }}</span>
                                    <span class="text-danger" v-else-if="u.user.status_sekarang == 'TERISOLIR'">{{ u.user.status_sekarang }}</span>
                                    <span class="text-info" v-else-if="u.user.status_sekarang == 'PENDING BAYAR ONLINE'">{{ u.user.status_sekarang }}</span>
                                    <span class="text-success" v-else>{{ u.user.status_sekarang }}</span>
                                  </td>
                                  <td class="text-center" :for="u.user.uid">
                                    <span>
                                      
                                      <router-link :to="{ name: 'pelanggan-detail', params: { id:u.user.uid, user: u.user, area: u.area}}"   class="btn btn-sm btn-info" ><i class="material-icons">remove_red_eye</i></router-link>
                                      

                                    </span>

                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                      </div>
                    </div>
                </div>
                
            </div>
        </div>


      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import router from '@/router'

export default {
  name: 'Beranda',
	components: { 
      "Loading" : Loading
	}, 
  setup() {
    const dataAll = reactive({
      loading: true,
      bulan: '0',
      tahun: '0',
      telepon: null,
      ppn: '',
      infoShow: -1,
      prefix: ''
    })

    const theGet = {
      data: reactive({
        List: [],
      }),
      
      cariTeleponApi() {
        this.loading = true;
        var data = new FormData();
        data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
        data.append('cari', dataAll.telepon);
        data.append('bulan', "0");
        data.append('tahun', "0");
        data.append('type', "all");
        data.append('by', "nama");
        //data.append('area', null);
        //data.append('tanggal', null);
        //data.append('admin', null); // JIKA NULL GA USAH DIKIRIM
        
        var apiUrl = inter.PelangganListCari();
        myGlobal.call(data,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          dataAll.loading = false;
          if (x.status == true) {
            theGet.data.List = x.data;
            
            
          } else {
            //alert(x.pesan);
            this.textCariPelanggan = x.pesan;
          }
        })
      },
    }

    return {
      dataAll,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Cari Cepat";

    this.dataAll.namaQ = sessionStorage.getItem('admin');

    this.dataAll.bulan = myGlobal.getBulan();
    this.dataAll.tahun = myGlobal.getTahunNow();

    let prefix = sessionStorage.getItem('prefix');
    if (prefix != null) {
      this.dataAll.prefix = prefix;
    } else {
      this.dataAll.prefix = "#";
    }

    this.dataAll.ppn = myGlobal.PPN();


    //console.log(JSON.stringify(this.$route.params.cari))
    
    let carieTOd = this.$route.params.cari
    this.dataAll.telepon = carieTOd

    if(carieTOd) {
      this.theGet.cariTeleponApi()
    }
    // this.theGet.History();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
  display: inherit;
}
.box-menu {
    padding: 15px;
}
.box-menu > i {
    font-size: 25pt;
}
.tombol {
  cursor: pointer;
}
.info {
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  z-index: 999999999;
  margin-top: -50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan/cari/main.vue